<template>
  <v-layout column v-if="rankingParameter.length">
    <v-flex>
      <v-layout row class="gap-10 pt-1 pr-1 pl-1">
        <v-flex xs8>
          <v-layout column class="gap-10">
            <Header :header="header['overall']">
              <template v-slot:header>
                <v-layout row align-center class="header-title">
                  <div :style="{ width: '95.5%' }" class="pl-4rem pt-1">{{ $t('Overall Performance') }}</div>
                  <div>
                    <v-tooltip color="bg" bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on">info</v-icon>
                      </template>
                      <div id="hover__card" class="tool-tip__color">
                        <h2 class="text-xs-center">{{ $t('Overall performance info') }}</h2>
                        <p>
                          {{ $t('Overall performance of inverter is derived from individual ranking buckets. Lower the points(pts) will be considered as higher in performance.') }}
                        </p>
                      </div>
                    </v-tooltip>
                  </div>
                </v-layout>
              </template>
            </Header>
            <Header :header="header['ranking-trend']">
              <template v-slot:header>
                <div>
                  <v-layout row align-center class="header-title">
                    <div :style="{ width: '78%' }" class="pl-4rem pt-1">{{ $t('Ranking Trends') }}</div>
                    <div :style="{ width: '19.3%' }">
                      <CustomSelect :selectId="1" :items="rankingParameter"
                        @selectChangeHandler1="(val) => selectedParameter = val"
                        :selectedItem="selectedParameter" />
                    </div>
                  </v-layout>
                </div>
              </template>
            </Header>
          </v-layout>
        </v-flex>
        <v-flex xs4>
          <!-- Best PERFORMING INVERTER -->
          <PRCard :header="header['best-performing-inverter']" />
        </v-flex>
      </v-layout>
    </v-flex>

    <v-flex>
      <v-layout column class="pt-1 pr-1 pl-1">
        <div class="graph-header graph-header__background mt-1">
          <v-layout row align-center class="header-title pl-3rem">
            <div :style="{ width: '85%' }" class="graph-header__text">{{ $t('Inverter Ranking based on') }}
              {{ inverterRankingParameter ? $t(inverterRankingParameter.key) : '' }}</div>
            <div :style="{ width: '11.5vw' }">
              <CustomSelect :selectId="2" :items="rankingParameter"
                @selectChangeHandler2="(val) => inverterRankingParameter = val"
                :selectedItem="inverterRankingParameter" />
            </div>
          </v-layout>
        </div>
        <div>
          <v-layout row class="column-gap-3">
            <v-flex xs7>
              <div class="graph-card">
                <div class="d-flex pt-1">
                  <v-flex xs9 class="pl-3-3rem">{{ `${$t(dateInfo)} ${inverterRankingParameter ? $t(inverterRankingParameter.key) : ''}` }}
                    {{ $t('sorted in descending order') }}
                  </v-flex>
                  <v-flex xs3>
                    <Toggle :modelValue="currentView" :theme="theme"
                      @toggleValueChange="(val) => currentView = val">
                      <v-btn flat value="graph">
                        <span>{{ $t('Graph') }}</span>
                        <v-icon>bar_chart</v-icon>
                      </v-btn>
                      <v-btn flat value="table">
                        <span>{{ $t('Table') }}</span>
                        <v-icon>table_chart</v-icon>
                      </v-btn>
                    </Toggle>
                  </v-flex>
                </div>
                <div v-show="currentView == 'graph'">
                  <GlobalGraph class="graph" v-if="rankingSeries.length" :series="rankingSeries"
                    :xAxis="rankingXAxis" :yAxis="computedRankingYAxis" :showLegend="false" :graphID="1"
                    :theme="theme" />
                </div>
                <div v-if="currentView == 'table'">
                  <TableButtons :isReload="false" :isEmit="true"
                    @download:report="() => download()" />
                  <div class="paddingTopBottom1vw">
                    <RecyclerDataTable v-if="rankingTableData.length" :items="rankingTableData"
                      :headers="computedRankingTableHeader" :key_field="'name'"
                      :tableHeight="tableHeightRank" />
                  </div>
                </div>
              </div>
            </v-flex>
            <v-flex xs5>
              <PlantSummary :graphData="pieChartData" :info="pieChartInfo"
                :basedOn="inverterRankingParameter ? inverterRankingParameter.key : ''"
                :dateRangeType="this.activeFilter.selectedRange.text" :dateFrom="dateFrom"
                :dateTo="dateTo" />
            </v-flex>
          </v-layout>
        </div>
      </v-layout>
    </v-flex>

    <v-flex>
      <v-layout column class="mt-1 pr-1 pl-1">
        <v-layout row class="column-gap-3">
          <v-flex xs6>
            <div class="data-table-header data-table-header__background">
              <div class="graph-header__text">
                {{ $t('Data Table') }}
              </div>
              <div class="header-info">
                {{ $t('Aggregate values for all parameters') }} {{ overAllDateInfo }}
              </div>
            </div>
            <div class="table-card">
              <TableButtons :isReload="false" :isEmit="true"
                @download:report="() => download(true)" />
              <div class="paddingTopBottom1vw">
                <RecyclerDataTable v-if="dataTableData.length" :items="dataTableData"
                  :headers="computedDataTableHeader" :key_field="'name'" :tableHeight="tableHeight" />
              </div>
            </div>
          </v-flex>

          <v-flex xs6>
            <div class="data-table-header data-table-header__background">
              <div class="graph-header__text">
                {{ $t('Heat Map') }}
              </div>
              <div class="header-info">
                {{ $t('Inverter data visualization vs parameters') }} {{ overAllDateInfo }}
              </div>
            </div>
            <div class="table-card">
              <div class="d-flex">
                <v-spacer></v-spacer>
                <v-flex xs4>
                  <Toggle :modelValue="currentViewHeatmap" :theme="theme"
                    @toggleValueChange="(val) => currentViewHeatmap = val">
                    <v-btn flat value="heatmap">
                      <span>{{ $t('Heat Map') }}</span>
                      <v-icon>bar_chart</v-icon>
                    </v-btn>
                    <v-btn flat value="graph">
                      <span>{{ $t('Graph') }}</span>
                      <v-icon>bar_chart</v-icon>
                    </v-btn>
                  </Toggle>
                </v-flex>
              </div>
              <div v-show="currentViewHeatmap === 'heatmap'">
                <GlobalGraph class="heatmap__graph" v-if="heatMapData.length" :isMagicType="false"
                  :visualMap="heatMapVisualMap" :series="heatMapData" :yAxis="computedHeatMapYAxis"
                  :xAxis="heatMapXAxis" :showLegend="false" :graphID="2" :isHoverFix="false"
                  :theme="theme" />
              </div>
              <div v-show="currentViewHeatmap === 'graph'" class="overall-rank__graph">
                <GlobalGraph class="graph" v-if="overallRankingSeries.length"
                  :series="computedOverallRankingSeries" :xAxis="overallRankingXAxis"
                  :yAxis="computedOverallRankingYAxis" :graphID="3" :theme="theme" />
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
const momentTz = require('moment-timezone')
import _ from 'lodash'
import {
  filterMixin
} from '@/util/mixin/index'
import {
  mapGetters,
  mapMutations
} from 'vuex'
import CustomSelect from '@/components/common/CustomSelect'
import TableButtons from '@/components/CustomReport/TableButtons'
import {
  mapGettersMixin
} from '@/util/mixin/index.js'
import Header from '@/components/InverterRanking/Header'
import PRCard from '@/components/InverterRanking/Card'
import PlantSummary from '@/components/InverterRanking/PlantSummary'
import Ranking from '@/services/InverterRanking.js'

export default {
  mixins: [mapGettersMixin, filterMixin],
  components: {
    CustomSelect,
    TableButtons,
    Header,
    PRCard,
    PlantSummary
  },
  data() {
    return {
      isWatchEnabled: false,
      currentView: 'graph',
      currentViewHeatmap: 'heatmap',
      selectedParameter: {
        key: 'Generation (kWh)',
        value: 'energy'
      },
      inverterRankingParameter: {
        key: 'Generation (kWh)',
        value: 'energy'
      },
      dateFrom: null,
      dateTo: null,
      showCard: true,
      isLoaded: false,
      dataTableHeader: [],
      dataTableData: [],
      rankingTableData: [],
      rankingTableHeader: [],
      header: {},
      rankingSeries: [],
      rankingXAxis: {},
      computedRankingYAxis: [],
      rankingYAxis: [{
        name: '',
        axisLabel: {
          formatter: '{value}',
          rotate: 40
        }
      }],
      heatMapData: [],
      heatMapVisualMap: {
        min: 0,
        max: 24,
        inRange: {
          color: ['#1FCF8E', '#E6DB72', '#F66747']
        },
        calculable: true,
        orient: 'horizontal',
        left: '43.5%',
        top: 15
      },
      heatMapXAxis: {
        type: 'category',
        data: [],
        axisLabel: {
          interval: 0,
          rotate: 30
        },
        splitArea: {
          show: true
        }
      },
      computedHeatMapYAxis: [],
      heatMapYAxis: [{
        type: 'category',
        data: [],
        nameTextStyle: {
          align: 'left'
        },
        splitArea: {
          show: true
        }
      }],
      overallRankingSeries: [],
      overallRankingXAxis: {},
      computedOverallRankingYAxis: [],
      overallRankingYAxis: [{
        name: 'Total Points',
        axisLabel: {
          formatter: '{value}',
          rotate: 40
        }
      }],
      pieChartData: [],
      pieChartInfo: {},
      dateInfo: ''
    }
  },
  computed: {
    ...mapGetters(['getGeneralState', 'getSelectedPlantId', 'getActivePlantInfo', 'getPlantName', 'getRules']),
    currentLanguage() {
      return this.getGeneralState('language')
    },
    activeFilter() {
      return this.getGeneralState('activeFilterOption')
    },
    activeWatch() {
      return `${this.dateFrom} ${this.dateTo}`
    },
    tableHeight() {
      const screenResWidth = window.screen.width * window.devicePixelRatio
      if (screenResWidth <= 2544 && screenResWidth >= 1904) {
        return '55vh'
      } else if (screenResWidth <= 1904 && screenResWidth >= 1584) {
        return '55vh'
      } else if (screenResWidth <= 1584 && screenResWidth >= 1394) {
        return '53vh'
      } else if (screenResWidth <= 1432 && screenResWidth >= 1280) {
        return '50vh'
      } else {
        return '50vh'
      }
    },
    tableHeightRank() {
      const screenResWidth = window.screen.width * window.devicePixelRatio
      if (screenResWidth <= 2544 && screenResWidth >= 1904) {
        return '30vh'
      } else if (screenResWidth <= 1904 && screenResWidth >= 1584) {
        return '27vh'
      } else if (screenResWidth <= 1584 && screenResWidth >= 1394) {
        return '23vh'
      } else if (screenResWidth <= 1432 && screenResWidth >= 1280) {
        return '21vh'
      } else {
        return '21vh'
      }
    },
    watchDates() {
      return this.activeFilter.Date
        ? `${this.activeFilter.Date.from} ${this.activeFilter.Date.to}`
        : null
    },
    rankingParameter() {
      return this.getRules(['rule', 'access_config', 'ranking']) ? this.getRules(['rule', 'access_config', 'ranking']) : []
    },
    condition() {
      return {
        pr: {
          best: this.$t('Above 80'),
          average: this.$t('Between 75 & 80'),
          least: this.$t('Below 75')
        },
        efficiency: {
          best: this.$t('Above 98'),
          average: this.$t('Between 90 & 98'),
          least: this.$t('Below 90')
        },
        energy: {
          best: this.$t('Generation above "4*INV DC Capacity)"'),
          average: this.$t('Generation between "3.8*INV DC Capacity" and "3.5*INV DC Capacity"'),
          least: this.$t('Generation below "3.5*INV DC Capacity"')
        },
        ac_yield: {
          best: this.$t('Above 4'),
          average: this.$t('Between 3.5 & 4'),
          least: this.$t('Below 3.5')
        },
        down_time: {
          best: this.$t('Below 10 min'),
          average: this.$t('Between 10min & 15min'),
          least: this.$t('More than 15min')
        },
        down_energy: {
          best: this.$t('Below 60'),
          average: this.$t('Between 60 & 100'),
          least: this.$t('More than 100')
        }
      }
    },
    computedDataTableHeader() {
      const tempHeader = _.cloneDeep(this.dataTableHeader)
      return tempHeader.map(el => {
        el.key = this.$t(el.key)
        return el
      })
    },
    computedRankingTableHeader() {
      const tempHeader = _.cloneDeep(this.rankingTableHeader)
      return tempHeader.map(el => {
        el.key = this.$t(el.key)
        return el
      })
    },
    computedOverallRankingSeries() {
      const cloneSeries = _.cloneDeep(this.overallRankingSeries)
      return cloneSeries.map(el => {
        el.name = this.$t(el.name)
        return el
      })
    },
    overAllDateInfo() {
      if (this.activeFilter.selectedRange.text === 'Custom') {
        return `${this.$t('from')} ${this.dateFrom} ${this.$t('to')} ${this.dateTo}`
      } else {
        return `${this.$t('for')} ${this.$t(this.activeFilter.selectedRange.text)}`
      }
    }
  },
  async mounted() {
    if (this.rankingParameter.length > 0) {
      this.SET_PROGRESS_BAR(true)
      this.initialDates()
      await this.getRankingTrendHeader()
      await this.getOverallHeader()
      await this.getInverterWithPR()
      await this.getTableData()
      await this.getHeatmapData()
      if (this.activeFilter.selectedRange.text === 'Custom') {
        this.dateInfo = `${this.dateFrom} - ${this.dateTo}`
      } else {
        this.dateInfo = `${this.activeFilter.selectedRange.text}'`
      }
      this.SET_PROGRESS_BAR(false)
    } else {
      let payload = {
        icon: 'error',
        header: '',
        message: 'Parameters are not configured'
      }
      this.SET_SNACKBAR_CONTENT(payload)
      this.SET_SHOW_SNACKBAR(true)
    }
  },
  methods: {
    ...mapMutations([
      'SET_PROGRESS_BAR',
      'SET_SHOW_SNACKBAR',
      'SET_SNACKBAR_CONTENT',
      'SET_DEFAULT_DATE',
      'SET_ACTIVE_FILTER'
    ]),
    computeParam() {
      // Function runs only when the selected range value is not custom
      const param = {}
      param['type'] = this.activeFilter['selectedRange'].interval
      if (this.activeFilter['selectedRange'].interval === 'daily') {
        if (this.activeFilter['selectedRange'].offsetLevel === 'month') {
          param.from = momentTz().tz(this.getActivePlantInfo('timezone'))
            .subtract(
              this.activeFilter['selectedRange'].startOffset,
              this.activeFilter['selectedRange'].offsetLevel
            )
            .startOf(this.activeFilter['selectedRange'].offsetLevel)
            .format('YYYY-MM-DD')
          param.to = momentTz().tz(this.getActivePlantInfo('timezone'))
            .subtract(
              this.activeFilter['selectedRange'].endOffset,
              this.activeFilter['selectedRange'].offsetLevel
            )
            .endOf(this.activeFilter['selectedRange'].offsetLevel)
            .format('YYYY-MM-DD')
        } else {
          param.from = momentTz().tz(this.getActivePlantInfo('timezone'))
            .subtract(this.activeFilter['selectedRange'].startOffset, 'day')
            .format('YYYY-MM-DD')
          param.to = momentTz().tz(this.getActivePlantInfo('timezone'))
            .subtract(this.activeFilter['selectedRange'].endOffset, 'day')
            .format('YYYY-MM-DD')
        }
      } else if (this.activeFilter['selectedRange'].interval === 'monthly') {
        let format = 'YYYY-MM-DD'
        param.from = momentTz().tz(this.getActivePlantInfo('timezone'))
          .subtract(
            this.activeFilter['selectedRange'].startOffset,
            this.activeFilter['selectedRange'].offsetLevel
          )
          .startOf(this.activeFilter['selectedRange'].offsetLevel)
          .format(`${format}`)
        param.to = momentTz().tz(this.getActivePlantInfo('timezone'))
          .subtract(
            this.activeFilter['selectedRange'].endOffset,
            this.activeFilter['selectedRange'].offsetLevel
          )
          .endOf(this.activeFilter['selectedRange'].offsetLevel)
          .format(`${format}`)
      }
      return param
    },
    initialDates() {
      if (this.activeFilter.selectedRange.text !== 'Custom') {
        let param = this.computeParam()
        this.SET_ACTIVE_FILTER({
          Date: {
            from: param.from,
            to: param.to
          }
        })
        this.dateFrom = param.from
        this.dateTo = param.to
      } else {
        const yesterday = momentTz().tz(this.getActivePlantInfo('timezone'))
          .subtract(1, 'day')
          .format('YYYY-MM-DD')
        this.SET_DEFAULT_DATE(yesterday)
        this.dateFrom = yesterday
        this.dateTo = yesterday
      }
    },
    async getOverallHeader() {
      try {
        this.$set(this.header, 'overall', {})
        if (this.rankingParameter.length) {
          const response = await Ranking.getOverallHeader(
            this.getSelectedPlantId
          )
          this.header['overall'] = response.data.message
        }
      } catch (err) {
        console.log(err)
      }
    },
    async getRankingTrendHeader() {
      try {
        const response = await Ranking.getRankingHeader(
          this.getSelectedPlantId,
          this.selectedParameter ? this.selectedParameter.value : ''
        )
        this.$set(this.header, 'ranking-trend', {})
        this.header['ranking-trend'] = response.data.message
      } catch (err) {
        this.$set(this.header, 'ranking-trend', {})
        this.header['ranking-trend'] = []
        console.log(err)
      }
    },
    async getInverterWithPR() {
      try {
        const response = await Ranking.getPrPerformance(
          this.getSelectedPlantId
        )
        this.$set(this.header, 'best-performing-inverter', {})
        this.header['best-performing-inverter'] = response.data.message
      } catch (err) {
        this.$set(this.header, 'best-performing-inverter', {})
        this.header['best-performing-inverter'] = []
        console.log(err)
      }
    },
    async getTableData() {
      this.isWatchEnabled = true
      try {
        const param = {
          plantId: this.getSelectedPlantId,
          fromDate: this.dateFrom,
          toDate: this.dateTo
        }
        if (this.inverterRankingParameter) {
          const response = await Ranking.getTableData(param)
          this.sortRankingTableHandler(response.data.message.data)
        }
      } catch (err) {
        this.rankingSeries = []
        this.dataTableHeader = []
        this.dataTableData = []
        this.rankingTableHeader = []
        this.rankingTableData = []
        console.log(err)
      }
    },
    sortRankingTableHandler(data) {
      this.rankingSeries = []
      this.dataTableData = []
      this.rankingTableData = []
      this.rankingTableHeader = []
      const barRanking = {}
      const performanceCount = {
        best: 0,
        average: 0,
        least: 0
      }
      const sortedData = _.orderBy(data, o => +o[this.inverterRankingParameter.value] || 0, ['desc'])
      barRanking['data'] = sortedData.map((el) => el[this.inverterRankingParameter.value])
      barRanking['type'] = 'bar'
      // This name is used in the tooltip and is according to the select value
      barRanking['name'] = `${this.inverterRankingParameter.key}`
      this.rankingSeries.push(barRanking)
      this.$set(
        this.rankingXAxis,
        'data',
        sortedData.map((el) => el.name)
      )
      this.$set(this.rankingXAxis, 'axisLabel', {
        interval: 0,
        rotate: 20,
        color: '#ffffff'
      })
      this.rankingYAxis[0].name = `${this.inverterRankingParameter.key}`
      const clonedYAxis = _.cloneDeep(this.rankingYAxis)[0]
      const tempName = this.$t(clonedYAxis.name)
      clonedYAxis.name = tempName
      this.$set(this.computedRankingYAxis, 0, clonedYAxis)

      // Data table
      data.forEach((el) => {
        const dataTableData = {}
        const rankingTableData = {}
        // For energy you need to calculate with the help of dc capacity
        const optional =
          this.inverterRankingParameter.value === 'energy'
            ? el['dcCapacity']
            : null
        const performance = this.summaryConditionHandler(
          this.inverterRankingParameter.value,
          el[this.inverterRankingParameter.value],
          optional
        )

        performanceCount[performance.toLowerCase()]++
        Object.keys(el).forEach((key) => {
          if (key !== 'id') {
            dataTableData[key] = el[key]
            if (key === 'name') {
              // adding name in ranking table data
              rankingTableData[key] = el[key]
            }
          }
          // SELECTION SHOULD BE EQUAL TO THE PARAMETER NAME
          if (this.inverterRankingParameter.value === key) {
            rankingTableData[key] = el[key]
          }
        })
        this.rankingTableHeader = [
          ...[{
            key: 'Inverter',
            value: 'name',
            sortable: true
          },
          {
            key: this.inverterRankingParameter.key,
            value: this.inverterRankingParameter.value,
            sortable: true
          }
          ]
        ]
        this.dataTableData.push(dataTableData)
        this.dataTableHeader = [ { key: 'Inverter', value: 'name' }, ...this.rankingParameter ].map(el => {
          el['sortable'] = true
          return el
        })
        this.rankingTableData.push(rankingTableData)
      })
      this.pieChartData = [{
        value: performanceCount.best,
        name: 'Best',
        itemStyle: {
          color: '#1FCF8E'
        }
      },
      {
        value: performanceCount.average,
        name: 'Average',
        itemStyle: {
          color: '#E6DB72'
        }
      },
      {
        value: performanceCount.least,
        name: 'Least',
        itemStyle: {
          color: '#F66747'
        }
      }
      ]
      this.pieChartInfo = this.condition[this.inverterRankingParameter.value]
    },
    async getHeatmapData() {
      try {
        const param = {
          plantId: this.getSelectedPlantId,
          fromDate: this.dateFrom,
          toDate: this.dateTo
        }
        const response = await Ranking.getHeatMapRank(param)
        const data = {}
        data['data'] = []
        data['name'] = 'Heat map'
        data['type'] = 'heatmap'
        data['label'] = {
          show: true
        }

        const heatMap = [...this.rankingParameter, { key: 'Total', value: 'total' }]
        const deviceName = []
        const totalPoints = []
        const sortedData = _.sortBy(response.data.message, ['name'])
        sortedData.forEach((el, index) => {
          deviceName.push(el.name)
          let total = 0
          heatMap.forEach((obj, i) => {
            if (obj.value !== 'total') {
              if (el[obj.value]) {
                total = total + el[obj.value]
              }
              data['data'].push([index, i, el[obj.value]])
            } else {
              const totalObject = {}
              totalObject['name'] = el.name
              totalObject['value'] = total
              totalPoints.push(totalObject)
            }
          })
        })
        // Heatmap data
        this.overallRankingSeries = []
        this.heatMapData = []
        this.heatMapYAxis[0].data = []
        this.heatMapXAxis.data = []
        this.heatMapYAxis[0].data.push(
          ...heatMap.slice(0, heatMap.length - 1).map(el => {
            if (el.key.split(' ').length > 2) {
              el.key = el.key.replace(' ', '\n')
            }
            return el.key
          })
        )
        const tempObj = _.cloneDeep(this.heatMapYAxis)[0]
        const tempArr = tempObj.data.map(names => {
          if (this.$t(names).split(' ').length > 2) {
            names = this.$t(names).replace(' ', '\n')
          } else {
            names = this.$t(names)
          }
          return names
        })
        tempObj.data = tempArr
        this.computedHeatMapYAxis = [tempObj]
        this.heatMapXAxis.data.push(...deviceName)
        this.heatMapData.push(data)
        const tempMaxMinFinder = data['data'].map((el) => el[2])
        const maxRange = _.max(tempMaxMinFinder)
        const minRange = _.min(tempMaxMinFinder)
        this.heatMapVisualMap.max = maxRange
        this.heatMapVisualMap.min = minRange
        // Overall Ranking Bar graph
        const barRanking = {}
        const sortedTotalPoints = _.orderBy(totalPoints, o => +o['value'] || 0, ['desc'])
        barRanking['data'] = sortedTotalPoints.map((el) => el.value)
        barRanking['type'] = 'bar'
        // This name is used in the tooltip and is according to the select value
        barRanking['name'] = 'Total Points'
        this.overallRankingSeries.push(barRanking)
        this.$set(
          this.overallRankingXAxis,
          'data',
          sortedTotalPoints.map((el) => el.name))
        this.$set(this.overallRankingXAxis, 'axisLabel', {
          interval: 0,
          rotate: 20,
          color: '#ffffff'
        })
        const clonedYAxis = _.cloneDeep(this.overallRankingYAxis)[0]
        const tempName = this.$t(clonedYAxis.name)
        clonedYAxis.name = tempName
        this.$set(this.computedOverallRankingYAxis, 0, clonedYAxis)
      } catch (err) {
        this.overallRankingSeries = []
        this.heatMapData = []
        this.heatMapYAxis[0].data = []
        this.computedHeatMapYAxis = []
        this.heatMapXAxis.data = []
        console.log(err)
      }
    },
    summaryConditionHandler(param, value, optional) {
      switch (param) {
        case 'energy':
          if (optional * 4 <= value) {
            return 'best'
          } else if (optional * 3.8 >= value && value >= optional * 3.5) {
            return 'average'
          } else {
            return 'least'
          }
        case 'efficiency':
          if (value > 98) {
            return 'Best'
          } else if (value <= 98 && value >= 90) {
            return 'Average'
          } else {
            return 'Least'
          }
        case 'pr':
          if (value > 80) {
            return 'Best'
          } else if (value <= 80 && value >= 75) {
            return 'Average'
          } else {
            return 'Least'
          }
        case 'ac_yield':
          if (value > 4) {
            return 'Best'
          } else if (value <= 4 && value >= 3.5) {
            return 'Average'
          } else {
            return 'Least'
          }
        case 'down_time':
          if (value < 10 || value === null) {
            return 'Best'
          } else if (value >= 10 && value <= 15) {
            return 'Average'
          } else {
            return 'Least'
          }
        case 'down_energy':
          if (value < 60 || value === null) {
            return 'Best'
          } else if (value >= 60 && value <= 100) {
            return 'Average'
          } else {
            return 'Least'
          }
      }
    },
    download(downloadAll = false) {
      const map = [{
        key: 'Inverter',
        value: 'name'
      }, ...this.rankingParameter]
      const param = {
        plantId: this.getSelectedPlantId,
        plantName: this.getPlantName(this.getSelectedPlantId),
        fromDate: this.dateFrom,
        toDate: this.dateTo,
        download: {
          parameters: downloadAll ? [] : [this.inverterRankingParameter.value]
        },
        parameterMap: map
      }
      let encoded = btoa(JSON.stringify(param))
      Ranking.downloadReport(encoded, downloadAll ? 'DataTable' : 'RankingTrend')
    }
  },
  watch: {
    async getSelectedPlantId() {
      if (this.rankingParameter.length === 0) {
        let payload = {
          icon: 'error',
          header: '',
          message: 'Parameters are not configured'
        }
        this.SET_SNACKBAR_CONTENT(payload)
        this.SET_SHOW_SNACKBAR(true)
      } else {
        this.selectedParameter = this.rankingParameter[0]
        this.inverterRankingParameter = this.rankingParameter[0]
        this.SET_PROGRESS_BAR(true)
        this.initialDates()
        await this.getRankingTrendHeader()
        await this.getOverallHeader()
        await this.getInverterWithPR()
        await this.getTableData()
        await this.getHeatmapData()
        if (this.activeFilter.selectedRange.text === 'Custom') {
          this.dateInfo = `${this.dateFrom} - ${this.dateTo}`
        } else {
          this.dateInfo = `${this.activeFilter.selectedRange.text}'`
        }
        this.SET_PROGRESS_BAR(false)
      }
    },
    'activeFilter.selectedRange.text'() {
      if (this.activeFilter.selectedRange.text === 'Custom') {
        this.dateInfo = `${this.dateFrom} - ${this.dateTo}`
      } else {
        this.dateInfo = `${this.activeFilter.selectedRange.text}`
      }
      this.initialDates()
    },
    inverterRankingParameter() {
      if (this.isWatchEnabled && this.inverterRankingParameter) {
        this.sortRankingTableHandler(this.dataTableData)
      }
    },
    selectedParameter() {
      if (this.isWatchEnabled && this.selectedParameter) {
        this.getRankingTrendHeader()
      }
    },
    async activeWatch(val, oldVal) {
      if (this.isWatchEnabled && !oldVal.includes('null')) {
        this.SET_PROGRESS_BAR(true)
        await this.getTableData()
        await this.getHeatmapData()
        this.SET_PROGRESS_BAR(false)
      }
    },
    watchDates(val, oldVal) {
      if (
        this.activeFilter.selectedRange.text === 'Custom' &&
        oldVal !== null
      ) {
        this.dateFrom = val.split(' ')[0]
        this.dateTo = val.split(' ')[1]
      }
    },

    currentLanguage() {
      const cloneYAxis = _.cloneDeep(this.heatMapYAxis)
      const tempObj = cloneYAxis[0]
      const tempArray = tempObj.data.map(names => {
        if (this.$t(names).split(' ').length > 2) {
          names = this.$t(names).replace(' ', '\n')
        } else {
          names = this.$t(names)
        }
        return names
      })
      tempObj.data = tempArray
      this.$set(this.computedHeatMapYAxis, 0, tempObj)
      const clonedYAxis = _.cloneDeep(this.overallRankingYAxis)[0]
      const tempName = this.$t(clonedYAxis.name)
      clonedYAxis.name = tempName
      this.$set(this.computedOverallRankingYAxis, 0, clonedYAxis)
      
      const clonedRankingYAxis = _.cloneDeep(this.rankingYAxis)[0]
      const tempRankingName = this.$t(clonedRankingYAxis.name)
      clonedRankingYAxis.name = tempRankingName
      this.$set(this.computedRankingYAxis, 0, clonedRankingYAxis)
    }
  }
}
</script>

<style scoped>
.gap-10 {
  gap: 10px;
}

.column-gap-3 {
  column-gap: 3px;
}

.pl-3-3rem {
  padding-left: 3.3rem !important;
}

.pl-3rem {
  padding-left: 3.5rem !important;
}

.pl-4rem {
  padding-left: 4rem !important;
}

.sub-container {
  padding: 6px 6px 0px 6px;
}

.sub-container1 {
  padding: 2px 6px 0px 6px;
}

.graph-header {
  height: 58px;
  border-radius: 5px 5px 0px 0px;
}

.theme--dark .graph-header__background {
  background-color: var(--v-primary-base);
}

.theme--light .graph-header__background {
  background-color: var(--v-grey-base);
}

.data-table-header {
  padding-top: 7px;
  padding-left: 3.5rem;
  height: 58px;
  border-radius: 5px 5px 0px 0px;
}

.theme--dark .data-table-header__background {
  background-color: var(--v-primary-base);
}

.theme--light .data-table-header__background {
  background-color: var(--v-grey-base);
}

.graph-header__text {
  font-weight: 600;
  font-size: 18px;
}

.graph-card {
  height: 50.5vh;
  background-color: var(--v-primary-base);
}

.table-card {
  height: 70vh;
  background-color: var(--v-primary-base);
}

.header-title {
  font-size: 18px;
  font-weight: 700;
  padding-top: 10px;
}

.header-info {
  font-size: 12px;
  font-weight: 400;
  padding-top: 3px;
}

.header-layout {
  padding-left: 3.5rem;
}

.graph {
  width: 100%;
  height: 42.5vh;
}

.heatmap__graph {
  width: 100%;
  height: 65vh;
}

#hover__card {
  width: 320px;
  padding: 10px;
}

.paddingTopBottom1vw {
  padding: 0vw 1vw;
}

.overall-rank__graph {
  margin-top: 5rem;
}
</style>

<style>
.theme--light .tool-tip__color {
  color: #000;
}
</style>
